import { createFeatureSelector } from '@ngrx/store';
import { createApiCallSelectors } from '../../../common/store/generic.selectors';
import { ListItem } from '../typeahead/types';
import { groupFeatureKey } from './types';
import { IGroupState } from './group.reducer';

const groupFeatureState = createFeatureSelector<IGroupState>(groupFeatureKey);

export const groupSelectors = {
  getListItem: createApiCallSelectors<ListItem[], IGroupState>(
    groupFeatureState,
    'getListItem',
  ),
};
